import { Select } from "@mantine/core";

import classNames from "./Select.module.css";

export const selectComponentSettings = Select.extend({
  defaultProps: {},
  classNames,
});
